import dayjs from "dayjs";

export const REQUEST_TYPE_LABELS = {
  TENANT_NEW: "New tenant vehicle",
  TENANT_UPDATE: "Tenant vehicle update",
  GUEST: "Guest vehicle",
  GUEST_UPDATE: "Guest vehicle update",
};

// Guest invites and guest changes to an approved guest vehicle
export const isGuestType = (type) => type === "GUEST" || type === "GUEST_UPDATE";

// Changes to an existing vehicle (compared against the current vehicle)
export const isUpdateType = (type) => type === "TENANT_UPDATE" || type === "GUEST_UPDATE";

export const apiErrorMessage = (error, fallback) => error?.response?.data?.message || fallback;

export const formatDateTime = (value) => (value ? dayjs(value).format("MMM D, YYYY h:mm A") : "-");

export const formatDate = (value) => (value ? dayjs(value).format("MMM D, YYYY") : "-");
